




import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class ScheduleTypeIcon extends Vue {
  @Prop({ default: '' })
  type!: string

  get icon() {
    return require(`@/assets/icons/${this.iconName}.png`)
  }

  get iconName() {
    //TODO: EventTypeはfixしていない
    const icons: { [key: string]: string } = {
      訪問看護: 'houmon',
      注射: 'tyuusha',
      投薬: 'touyaku',
      処置: 'shochi',
      画像検査: 'gazoukensa',
      テレビ電話: 'TVdenwa',
      コメント: 'komento'
    }
    return icons[this.type]
  }
}
